import React, { useState, useEffect, useRef } from 'react';
import DateRangeFilter from '../dateRangeFilter';
import { getListStatusFacturation } from '../../../client/facturation';

const ListFilterBillingAdmin = ({
  titleOption = "Filtrar",
  applyFilters,
  resetFlag,
  activeFilters = {},
  widthPx = 105,
  position = "md:right-0 right-auto"
}) => {

  const [showFilters, setShowFilters] = useState(false);

  const [estadoOptions, setEstadoOptions] = useState([]);
  const [selectedEstado, setSelectedEstado] = useState([]);
  const [loadingEstado, setLoadingEstado] = useState(false);

  const [selectedEmissionDateRange, setSelectedEmissionDateRange] = useState({
    startDate: '',
    endDate: ''
  });
  
  const hasLoadedEstados = useRef(false);

  useEffect(() => {
    setSelectedEstado([]);
  }, [resetFlag]);

  useEffect(() => {
    if (activeFilters.statusIds && activeFilters.statusIds.length > 0 && estadoOptions.length > 0) {
      const selectedOptions = estadoOptions.filter(option => 
        activeFilters.statusIds.includes(option.value)
      );
      setSelectedEstado(selectedOptions);
    } else if (!activeFilters.statusIds || activeFilters.statusIds.length === 0) {
      setSelectedEstado([]);
    }
    
    setSelectedEmissionDateRange({
      startDate: activeFilters.emissionDateFrom || '',
      endDate: activeFilters.emissionDateTo || ''
    });
  }, [activeFilters, estadoOptions]);

  useEffect(() => {
    if (showFilters && !hasLoadedEstados.current) {
      loadEstados();
      hasLoadedEstados.current = true;
    }
    
    if (!showFilters) {
      hasLoadedEstados.current = false;
    }
  }, [showFilters]);

  const loadEstados = async () => {
    setLoadingEstado(true);
    try {
      const response = await getListStatusFacturation();
      if (response.data && response.data.status) {
        const estadosMapeados = response.data.status.map(status => ({
          value: status.id, 
          label: status.name 
        }));
        setEstadoOptions(estadosMapeados);

        if (activeFilters.statusIds && activeFilters.statusIds.length > 0) {
          const selectedOptions = estadosMapeados.filter(option => 
            activeFilters.statusIds.includes(option.value)
          );
          setSelectedEstado(selectedOptions);
        } else {
          setSelectedEstado([]);
        }
      }
    } catch (error) {
      console.error('Error cargando estados de facturación:', error);
    } finally {
      setLoadingEstado(false);
    }
  };

  const toggleFilters = () => setShowFilters(!showFilters);

  const handleDateRangeChange = ({ startDate, endDate }) => {
    setSelectedEmissionDateRange({ startDate, endDate });
  };


  const handleApplyFilters = () => {
    const filtersToApply = {
      statusIds: selectedEstado.map(option => option.value),
      emissionDateFrom: selectedEmissionDateRange.startDate,
      emissionDateTo: selectedEmissionDateRange.endDate
    };
    applyFilters(filtersToApply);
    setShowFilters(false);
  };

  const hasActiveFilters = () => {
    const hasStatusFilters = activeFilters.statusIds && activeFilters.statusIds.length > 0;
    const hasDateFilters = activeFilters.emissionDateFrom && activeFilters.emissionDateTo;
    return hasStatusFilters || hasDateFilters;
  };

  return (
    <div className='relative' >
      <button
        onClick={toggleFilters}
        className={`flex items-center justify-center font-itcbook px-2 w-[${widthPx}px] border-blue-light text-sm border-[1px] h-[40px] rounded-lg ${
          hasActiveFilters() ? 'bg-blue-light text-white' : 'bg-transparent text-[#6B7280]'
        }`}
      >
        {titleOption}
      </button>
      
      {showFilters && (
        <div
          onClick={(e) => e.stopPropagation()}
          className={`md:p-4 p-4 md:px-5 bg-white absolute ${position} top-12 overflow-y-auto max-h-[400px] md:max-h-[450px] rounded-lg w-[266px] sm:w-[320px] z-10 shadow-[0px_1px_3px_0px_#0000004D,0px_4px_8px_3px_#00000026]`}
        >
          <div className='flex flex-col gap-4'>
            <p className='text-base text-blue font-itcbold'>Filtrar por</p>
            <div className='w-full h-[1px] md:my-2 bg-[#D9D9D9]'></div>

            {/* Estado 
            <div className='flex flex-col gap-2'>
              <p className='text-sm md:text-base text-blue font-itcbook'>Estado</p>
              <Select
                  isMulti
                  isLoading={loadingEstado}
                  options={estadoOptions}
                  value={selectedEstado}
                  onChange={handleEstadoChange}
                  placeholder="Seleccione estados"
                  className="text-sm font-itcbook"
                  noOptionsMessage={() => "No hay opciones disponibles"}
                  styles={selectStyles}
                />
            </div>
            */}

            {/* Fechas de creación */}
            <div className='flex flex-col gap-2'>
              <p className='text-sm md:text-base text-blue font-itcbook'>Fecha de creación</p>
              <DateRangeFilter
                onDateRangeChange={handleDateRangeChange}
                value={selectedEmissionDateRange}
              />
            </div>

            <div className="flex justify-center w-full pt-2">
              <button
                onClick={handleApplyFilters}
                className="underline text-blue font-itcbold"
              >
                Aplicar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ListFilterBillingAdmin;